import React, { useContext, useEffect, useMemo, useState } from "react";
import { Col, Input, Layout, Modal, Progress, Row, Tabs, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./UICoFile.module.scss";
import { useTranslation } from "react-i18next";
import { AppContext } from "../context/App.context";
import ImageFile from "src/assets/png/ImageFile.png";
import DocumentFile from "src/assets/png/DocumentFile.png";
import MediaFile from "src/assets/png/MediaFile.png";
import OtherFile from "src/assets/png/OtherFile.png";
import UnknownFile from "src/assets/png/UnknownFile.png";
import SharedWithMeFile from "src/assets/png/SharedWithMeFile.png";
import GroupFile from "src/assets/png/GroupFile.png";
import TrashFile from "src/assets/png/TrashFile.png";
import FolderIcon from "src/assets/png/FolderIcon.png";
import backIcon from "src/assets/png/comunityIcon/back.png";
import emptyTrash from "src/assets/png/recycle-bin.png";
//@ts-ignore
import _, { uniqBy } from "lodash";

import * as Auth from "../../service/auth.service";
import { checkEmpty, isCommunity, parseJwt, } from "src/service/util.service";
import * as Props from "../../props/util.props";
import HeaderSearch from "src/components/shared/headerSearch/HeaderSearch";
import { useNavigate, useLocation, useParams, useMatches } from "react-router-dom";
import useFetch, { CachePolicies } from "use-http";
import {
  APIFileEnpoint,
  getAboutLimitMain,
  getCurrentFolderMain,
  getCurrentSharedWithCallService,
  getFileFoldersMethodGet,
} from "src/service/files.service";
import { bytesToSize, bytesToSize_Split, calFreeSize_Split, calPercent, reverseArr, } from "src/service/files.util";
import MyFileContainer from "./Container/myFile/MyFileContainer";
import { FileContext, FileProviderContext } from "./File.context";
import GroupFileContainer from "./Container/groupFile/GroupFileContainer";
import TrashFileContainer from "./Container/trashFile/TrashFileContainer";
import ManageversionFileContainer from "./Container/manageversionFile/ManageversionFileContainer";
import UIUploadIcon from "./component/UIUploadIcon";
import UIModalCreateFolder from "./component/UIModalCreateFolder";
import UIModalUpload from "./component/UIModalUpload";
import UIModalRename from "./component/UIModalRename";
import UIModalMove from "./component/UIModalMove";
import UIModalShare from "./component/UIModalShare";
import UIModalDownload from "./component/UIModalDownload";
import UIModalConfrimDelete from "./component/UIModalConfrimDelete";
import { tabName, tabNameText } from "./properies.file";
import UIModalConfrimDeleteForever from "./component/UIModalConfrimDeleteForever";
import UIModalConfrimDeleteRestore from "./component/UIModalConfrimRestore";
import BoxDetailFile from "./component/BoxDetailFile";
import UIModalShareFile from "./component/UIModalShareFile";
import MediasContainer from "./Container/mediasFile/MediasContainer";
import LinksContainer from "./Container/linksFile/LinksContainer";
import UIShareLinkPopover from "./component/UIShareLinkPopover";
import UIModalConfrimEmptyTrash from "./component/UIModalConfrimEmptyTrash";
import CenterPageLayout from "../../layouts/CenterPageLayout";
import CenterConfirmModal from "src/components/shared/Modal/CenterConfirmModal";

const defaultLitmitOfset = 30;
let linkFiles = process.env.REACT_APP_FILE_SERVER + APIFileEnpoint.getFiles;
const { TabPane } = Tabs;

const { Header, Footer, Sider, Content } = Layout;

function UICoFileContainer(props: any) {
  const navigate = useNavigate();
  //have to check sharedWithMeRoute
  // const sharedWithMeRoute: any = useMatches({pathname:Props.pathRoutes.File + "/id/my-id/folder/:id"});
  const { t, i18n } = useTranslation();
  const appContext: any = useContext(AppContext);
  const fileContext: any = useContext(FileContext);

  const [userId, setUserId] = useState(parseJwt(Auth.getToken()).userID);
  const [groupId, setGroupId]: any = useState(props.id);

  const [showModal, setShowModal]: any = useState(true);
  const [activeKeyMainTab, setActiveKeyMainTab]: any = useState(props.maintab);
  const [offsetFile, setOffsetFile]: any = useState(0);
  const [isLoading, setIsLoading]: any = useState(false);
  const [initialPath, setInitialPath] = useState([]);

  const [page, setPage] = useState("files");
  // const [showS, setShowModal]: any = useState(true);

  useEffect(() => {
    fileContext.setGroupId(props.id);
  }, [props.id])


  useEffect(() => {
    fileContext.setUserId(parseJwt(Auth.getToken()).userID);
  }, [])

  useEffect(() => {
    fileContext.setParentFolderId(props.dirId);
  }, [props.dirId])


  useEffect(() => {
    fileContext.setViewDir(props.viewdir);
  }, [props.viewdir])

  useEffect(() => {
    fileContext.setIsComunity(props.isCommunity);
  }, [])

  useEffect(()=>{
    fileContext.setTab(props.tab);
    console.log("><:: tab",props.tab);
    
  },[props.tab])

  // appContext.setShowDownload(false);
  useEffect(() => {
    // appContext.setShowDownload(false);
    console.log("fileContext.groupId : ", fileContext.groupId);

    let idsTemp = fileContext.fileAbouts;
    console.log("idsTemp", idsTemp);
    for (let a = 0; a < idsTemp.length; a++) {
      try {
        // let lastref = localStorage.getItem("lastreffile");
        // if (lastref != idsTemp[a].key) {
        idsTemp[a]?.cancel();
        // }
      } catch (e) { }
    }
  }, []);

  const checkSetTab = () => {
    if (checkEmpty(props.tab) || tabName.myFile === props.tab) {
      fileContext.setTab("");
    } else if (props.tab === tabName.trash) {
      fileContext.setTab(tabName.trash);
    } else if (props.tab === tabName.sharedWithMe) {
      fileContext.setTab(tabName.sharedWithMe);
    } else if (fileContext.manageversion === tabName.manageversion) {
      fileContext.setTab(tabName.sharedWithMe);
    } else {
      // fileContext.setTab("");
    }
  };
  const getTabText = (tab: string) => {
    // console.log("Tab >: ", tab);

    if (checkEmpty(tab) || tabName.myFile === tab) {
      return tabNameText.myFile;
    } else if (tab === tabName.trash) {
      return t(tabNameText.trash);
    } else if (tab === tabName.sharedWithMe) {
      return t(tabNameText.sharedWithMe);
    } else if (tab === tabName.mediaimage) {
      return t(tabNameText.mediaimage);
    } else if (tab === tabName.mediavideo) {
      return t(tabNameText.mediavideo);
    } else if (tab === tabName.other) {
      return t(tabNameText.other);
    } else if (tab === tabName.unknow) {
      return t(tabNameText.unknow);
    } else if (tab === tabName.doc) {
      return t(tabNameText.doc);
    } else if (tab === tabName.search) {
      return t(tabNameText.search);
    } else {
      return t(tabNameText.myFile);
    }
  };
  const renderContainerMainTab = (tab: string) => {
    if (fileContext.groupId === Props.mainState.init) return;
    if (tab === Props.mainTab.medias) {
      return <MediasContainer />;
    } else if (tab === Props.mainTab.links) {
      return <LinksContainer />;
    }
  };

  const renderContainer = (tab: string, mainTab: string) => {
    if (
      fileContext.groupId === Props.mainState.init ||
      mainTab !== Props.mainTab.files
    )
      return;
    if (tab === tabName.myFile) {
      return <MyFileContainer />;
    } else if (tab === tabName.sharedWithMe) {
      // return <SharedFileContainer />;
      return <MyFileContainer isShared={props.isShared} />;
    } else if (tab === tabName.trash) {
      return <TrashFileContainer />;
    } else if (tab === tabName.group) {
      return <GroupFileContainer />;
    } else if (tab === tabName.mediavideo) {
      return <MyFileContainer />;
    } else if (tab === tabName.mediaimage) {
      return <MyFileContainer />;
    } else if (tab === tabName.other) {
      return <MyFileContainer />;
    } else if (tab === tabName.unknow) {
      return <MyFileContainer />;
    } else if (tab === tabName.doc) {
      return <MyFileContainer />;
    } else if (tab === tabName.search) {
      return <MyFileContainer />;
    }
    // else if (tab === tabName.manageversion) {
    //   return <ManageversionFileContainer />;
    //   }
    else {
      return <MyFileContainer isShared={props.isShared} />;
    }
  };

  useEffect(() => {
    console.log("isShared UiCofile container ", props.isShared);

  }, [props.isShared])

  const handleClickPath = (recursiveParent: any) => {
    fileContext.setTab("");
    let dirid = "";
    if (!checkEmpty(recursiveParent?.file_app_id))
      dirid = recursiveParent?.file_app_id;
    console.log(" recursiveParent : ", recursiveParent);
    console.log(" dirid : ", dirid);
    let id = fileContext.groupId;
    if (checkEmpty(id)) id = "";
    // navigate(Props.pathRoutes.File + "?id=" + id + "&dirid=" + dirid);
    // fileContext.setGroupId(id);
    // fileContext.setParentFolderId(dirid);
    if (checkEmpty(id)) id = Props.constKey.myId;
    if (fileContext.isComunity) {
      navigate(Props.pathRoutes.groupCommunity + "/" + id + "/folder/" + dirid + `&tab=file`, {
        state: { groupProps: props },
      });
    } else
      if (props.isShared && dirid) {
        navigate(Props.pathRoutes.File + "/id/" + id + "/folder/shared-with-me/" + dirid
        );
      } else
        navigate(Props.pathRoutes.File + "/id/" + id + "/folder/" + dirid);
  };

  const handleClickMainPath = () => {
    fileContext.setParentFolderId("");
    fileContext.setTab("");
    let id = fileContext.groupId;
    if (checkEmpty(id)) id = "";
    // navigate(Props.pathRoutes.File + "?id=" + id);
    // fileContext.setGroupId(id);
    // navigate(Props.pathRoutes.File + "?id=" + id);
    if (checkEmpty(id)) id = Props.constKey.myId;
    if (fileContext.isComunity) {
      navigate({
        pathname: Props.pathRoutes.groupCommunity + "/" + id,
        search: `?id=${id}&tab=file`,
      });
    } else navigate(Props.pathRoutes.File + "/id/" + id);
  };

  const handleClickSpotsPath = () => {
    console.log("SpotsPath");

  }

  const getRecursiveParents = useMemo(() => {
    if (fileContext.groupId === Props.mainState.init) return [];
    if (checkEmpty(fileContext.currentFolder?.recursiveParents)) return [];
    if (checkEmpty(initialPath)) return [];

    let recursiveParents = reverseArr(fileContext.currentFolder?.recursiveParents);
    let recursiveCurrentPath = reverseArr(initialPath);
    if (props.isShared) {
      if (recursiveParents[0]?.file_name === tabNameText.sharedWithMe) return recursiveParents;
      else
        if (recursiveParents?.length > 1) {
          recursiveCurrentPath.splice(2, recursiveParents?.length - 1, { file_name: "...", file_app_id: "" })
          recursiveCurrentPath.push(fileContext.currentFolder?.recursiveParents[0])
        }
      recursiveCurrentPath = uniqBy(recursiveCurrentPath, 'file_app_id');
      return recursiveCurrentPath;
    } else return uniqBy(recursiveParents, 'file_app_id');

  }, [fileContext.currentFolder, initialPath])

  useEffect(() => {
    checkSetTab();
    fileContext.setFilesSelected([]);
  }, []);

  useEffect(() => {
    checkSetTab();
  }, [fileContext.groupId, fileContext.parentFolderId]);

  useEffect(() => {
    if (fileContext.groupId === Props.mainState.init) return;
    getAboutLimit();
  }, [fileContext.groupId, fileContext.userId, fileContext.syncAboutLimit]);

  useEffect(() => {
    if (fileContext.groupId === Props.mainState.init) return;
    getCurrentFolder();
  }, [fileContext.parentFolderId]);

  useEffect(() => {
    if (fileContext.groupId === Props.mainState.init) return;
    getCurrentSharedWith();
  }, [fileContext.groupId, fileContext.userId]);

  useEffect(() => {
    fileContext.setFilesSelected([]);
    appContext.setShowDownload(false);
    appContext.setProgressLoadFiles(Object.assign([], []));
  }, [fileContext.mainTab]);

  const getCurrentSharedWith = async () => {
    try {
      let data = await getCurrentSharedWithCallService({
        userId: fileContext.userId,
        groupId: fileContext.groupId,
      });
      fileContext.setCurrentSharedWith(data);
      console.log("getCurrentSharedWith : ", data);
    } catch (e) {
      console.error(e);
    }
  };

  const getAboutLimit = async () => {
    try {
      let data = await getAboutLimitMain({
        userId: fileContext.userId,
        groupId: fileContext.groupId,
      });
      fileContext.setAboutLimit(data);
      console.log("getAboutLimit : ", data);
    } catch (e) {
      console.error(e);
    }
  };

  const getCurrentFolder = async () => {
    setIsLoading(true);
    // if (checkEmpty(props.dirId)) return;
    try {
      let data: any = await getCurrentFolderMain({
        groupId: fileContext.groupId,
        userId: fileContext.userId,
        file_app_id: fileContext.parentFolderId,
      });

      if (!data) {
        fileContext.setCurrentPath([]);
      }
      fileContext.setCurrentFolder(data);
      console.log("data   ", data);
    } catch (e) {
      console.error(e);
    }
    setIsLoading(false);
  };

  const getTotalLimit = () => {
    return fileContext.aboutLimit?.limitSize?.replace(" ", "");
  };

  const getTotalLimitSplit = () => {
    let res = calFreeSize_Split(
      fileContext.aboutLimit?.used,
      fileContext.aboutLimit?.limitSize
    );
    return res;
  };

  const getUsedLimitSplit = () => {
    return bytesToSize_Split(fileContext.aboutLimit?.used);
  };

  const getUsedLimit = () => {
    return fileContext.aboutLimit?.used
      ? bytesToSize(fileContext.aboutLimit?.used)?.replace(" ", "")
      : bytesToSize(0)?.replace(" ", "");
  };

  const getAboutLimitForTab = (tab: any) => {
    let res: any = { fileSize: 0, fileCount: 0 };
    res.fileSize = bytesToSize(0)?.replace(" ", "");
    if (
      checkEmpty(fileContext.aboutLimit) ||
      checkEmpty(fileContext.aboutLimit.tabs)
    )
      return res;
    let tabObj: any = fileContext.aboutLimit?.tabs[tab];
    if (checkEmpty(tabObj)) return res;
    res.fileSize = bytesToSize(tabObj.fileSize)?.replace(" ", "");
    res.fileCount = tabObj.fileCount;
    return res;
  };

  const getFileCountforTab = (tab: any) => {
    let fileCount = getAboutLimitForTab(tab).fileCount;
    let fileCountType: any = t("files");
    if (fileCount == 1) fileCountType = t("file");
    let fileCountText = fileCount + " " + fileCountType;
    return fileCountText;
  };

  const getColorLimitProgress = () => {
    let percent = calPercent(fileContext.aboutLimit);
    if (percent >= 100) {
      return "red";
    } else if (percent >= 90) {
      return "#ffc112";
    } else return "#0f4c82";
  };

  /*
  const handleClickTab = (tab: string) => {
    fileContext.setMainTab(Props.mainTab.files);
    setActiveKeyMainTab(Props.mainTab.files);
    let dirIdText = "";
    fileContext.setTab(tab);
    if (tab === tabName.sharedWithMe) {
      let dirid = fileContext?.currentSharedWith?.file_app_id;
      if (checkEmpty(dirid)) dirid = "";
      // fileContext.setParentFolderId(dirid);
      dirIdText = "&dirid=" + dirid;
    }
  
    console.log(parseJwt(Auth.getToken()).userID);
    let id = fileContext.groupId;
    if (checkEmpty(id)) id = "";
    fileContext.setTab(tab);
    // navigate(
    //   Props.pathRoutes.File + "?id=" + id + "&tab=" + tab + dirIdText
    // );
  
    fileContext.setGroupId(id);
    if (checkEmpty(id)) id = constKey.myId;
    if (tab === tabName.sharedWithMe) {
      let dirid = fileContext?.currentSharedWith?.file_app_id;
      if (checkEmpty(dirid)) dirid = "";
      fileContext.setParentFolderId(dirid);
      if (fileContext.isComunity) {
        navigate({
          pathname:
            Props.pathRoutes.groupCommunity + "/id/" + id + "/folder/" + dirid,
          search: `?id=${id}&tab=file`,
        });
      } else
        navigate(Props.pathRoutes.File + "/id/" + id + "/folder/" + dirid);
    } else {
      fileContext.setCurrentFolder({});
      if (fileContext.isComunity) {
        navigate({
          pathname:
            Props.pathRoutes.groupCommunity + "/id/" + id + "/tab/" + tab,
          search: `?id=${id}&tab=file`,
        });
      } else navigate(Props.pathRoutes.File + "/id/" + id + "/tab/" + tab);
    }
  };
  */
  const handleBack = () => {
    // window.history.back();
    navigate(-1);
    console.log("navigate(-1) ",props.tab);
    
  };

  const getClasActive = (tab: any) => {
    if (tab === fileContext.tab) return styles.boxMenuTabActive;
    else return "";
  };

  const getClasActiveShareWithMe = (tab: any) => {
    if (tab === fileContext.tab) return styles.boxMenuTabActive;
    let s = getRecursiveParents;
    if (s.length != 0 && s[0]?.file_name === "Shared with me") {
      return styles.boxMenuTabActive;
    } else return "";
  };

  const getGroupDetail = useFetch(
    process.env.REACT_APP_PLAYME_URL + "/api/v2/groups/",
    {
      // path: APIEnpoint.myApps,
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const getGroupDetailCall = async () => {
    await getGroupDetail.get(fileContext.groupId);
    console.log(
      "getGroupDetail.response?.data : ",
      getGroupDetail.response?.data
    );
    fileContext.setGroupDetail(getGroupDetail.response?.data);
  };

  useEffect(() => {
    if (!checkEmpty(fileContext.groupId)) {
      getGroupDetailCall();
    }
  }, [fileContext.groupId]);

  const getMainTextOfFile = () => {
    if (checkEmpty(fileContext.groupId)) return t("My Files");
    else {
      return fileContext.groupDetail?.name;
    }
  };

  // const getTextVersion = () => {
  //   let text = t("versions");
  //   if (fileContext.totalFileVersion === 0) text = t("version");
  //   return " (" + fileContext.totalFileVersion + " " + text + ") ";
  // };
  const showPath = () => {
    let res =
      fileContext.tab !== tabName.doc &&
      fileContext.tab !== tabName.other &&
      fileContext.tab !== tabName.unknow &&
      fileContext.tab !== tabName.mediaimage &&
      fileContext.tab !== tabName.mediavideo &&
      fileContext.tab !== tabName.file &&
      fileContext.tab !== tabName.search &&
      // fileContext.tab !== tabName.sharedWithMe &&
      fileContext.tab !== tabName.trash;
    return res;
  };

  const clickTabMain = (key: any, e: any) => {
    setActiveKeyMainTab(key);
    // setTimeout(function () {
    fileContext.setTab("");
    let id = fileContext.groupId;
    fileContext.setMainTab(key);

    if (checkEmpty(id)) id = "";
    if (key === "files") {
      setPage("files");
      handleClickPath({});
    } else if (key === "medias") {
      // navigate(Props.pathRoutes.File + "?id=" + id);
      // fileContext.setGroupId(id);
      setPage("medias");
      if (checkEmpty(id)) id = Props.constKey.myId;
      if (fileContext.isComunity) {
        navigate({
          pathname:
            Props.pathRoutes.groupCommunity + "/" + id + "/tab/" + key,
          search: `?id=${id}&tab=file`,
        });
      } else navigate(Props.pathRoutes.File + "/id/" + id + "/tab/" + key);
    } else if (key === "links") {
      setPage("links");
      // navigate(Props.pathRoutes.File + "?id=" + id);
      // fileContext.setGroupId(id);
      if (checkEmpty(id)) id = Props.constKey.myId;
      if (fileContext.isComunity) {
        navigate({
          pathname:
            Props.pathRoutes.groupCommunity + "/" + id + "/tab/" + key,
          search: `?id=${id}&tab=file`,
        });
      } else navigate(Props.pathRoutes.File + "/id/" + id + "/tab/" + key);
    }
    // }, 200);
  };

  const getItempText = () => {
    let len = fileContext.filesSelected?.length;
    if (len === 1) return t("item");
    else return t("items");
  };

  const cancelMedias = () => {
    fileContext.setFilesSelected(Object.assign([], []));
  };

  const downloadMedias = () => {
    appContext.setShowDownload(true);
    let files = fileContext.filesSelected;
    let filesTemp = [];
    for (let a = 0; a < files.length; a++) {
      if (!check(files[a])) {
        filesTemp.push(files[a]);
      }
    }

    fileContext.setFilesSelected(Object.assign([], []));
    appContext.setFilesToDownload(Object.assign([], filesTemp));
    appContext.setToDownloadFiles(true);
  };

  const check = (file: any) => {
    let files: any = appContext.progressLoadFiles;
    let found = false;
    for (let a = 0; a < files.length; a++) {
      if (file.file_app_id === files[a]?.file?.file_app_id) {
        found = true;
        break;
      }
    }
    return found;
  };

  const getClassScreen = () => {
    // if (page === "links") {
    //   return styles.screenLinkPage;
    // }
    return styles.screenPage;
  };

  const getClassMainBox = () => {
    if (isCommunity()) return styles.boxMainFileCommunity;
    return styles.boxMainFile;
  };

  const getClassMainBoxChild = () => {
    if (isCommunity()) return styles.backMainChildCom;
    return styles.backMainChild;
  }

  const getTabsClass = () => {
    if (isCommunity()) return styles.tabsCommunity;
    return styles.tabs;
  };

  const getClassPage = () => {
    if (page === "links") {
      return styles.boxLink;
    }
    return styles.boxFile;
  };

  const getUserData = () => {
    let token = Auth.getToken();
    let userdata: any = null;
    if (!checkEmpty(token)) {
      userdata = parseJwt(token);
    }
    return userdata;
  };

  const handlesearchItems = async (event: any) => {
    const value = event.target.value;
    // console.log(value);
    // console.log("==>", fileContext.fileSearchInput);
    if (!checkEmpty(value)) {
      fileContext.setFileSearchInput(value);
      fileContext.setTab(tabName.search)
    } else {
      fileContext.setFileSearchInput("");
      fileContext.setTab("")
    }

    // let param = {
    //   groupId: fileContext.groupId,
    //   userId: getUserData()?.userID,
    //   offset: offsetFile,
    //   limitOfset: defaultLitmitOfset,
    //   parentFolderId: fileContext.parentFolderId,
    //   tag: fileContext.tab,
    // };
    // let response: any = await getFileFoldersMethodGet(
    //   param,
    //   linkFiles,
    //   fileContext
    // );
    // console.log("res", response?.data?.data);
    // if (value !== "") {
    //   let fs = response.data.data?.filter((item: any) => {
    //     return item.file_name.toLowerCase().includes(value.toLowerCase());
    //     // Object.values(item).join('').toLowerCase().includes(filesearchInput.toLowerCase())
    //   });
    //   fileContext.setFileFolders(fs);
    //   fileContext.setshowRecentFiles(false);
    // } else {
    //   fileContext.setFileFolders(response?.data?.data);
    //   fileContext.setshowRecentFiles(true);

    // }
  };

  const handleClickEmptyTrash = () => {
    fileContext.setDisplayConfirmEmptyTrash(true);
  };

  let checkHiddenBtnCreateUpload = useMemo(() => {

    let s = getRecursiveParents;
    let hidden = (s[0]?.file_name === tabNameText.sharedWithMe) && (s.length == 1 || s.length == 2);
    if (hidden) {
      return hidden
    }
    if (!checkEmpty(fileContext.tab)) {
      hidden = true;
    }
    return hidden;

  }, [fileContext.currentPath, fileContext.tab])


  useEffect(() => {
    if (!fileContext.currentFolder || Object.keys(fileContext.currentFolder).length === 0) return;
    let index = fileContext?.currentPath?.findIndex((item: any) => item?.file_app_id === fileContext.currentFolder?.file_app_id);
    if (index > -1) {
      fileContext.setCurrentPath((prev: any[]) => [...prev.slice(index)])
    } else
      fileContext.setCurrentPath((prev: any[]) => [
        {
          file_app_id: fileContext.currentFolder?.file_app_id,
          file_name: fileContext.currentFolder?.file_name,
          parent_folder_id: fileContext.currentFolder?.parent_folder_id
        }, ...prev]);


  }, [fileContext.currentFolder])

  useEffect(() => {
    if (fileContext.currentPath.length > 0) {
      localStorage.setItem("currentPath", JSON.stringify(fileContext.currentPath));
    }
    setInitialPath(fileContext.currentPath);
  }, [fileContext.currentPath]);

  useEffect(() => {
    const currentPathFromStorage = localStorage.getItem("currentPath");
    if (currentPathFromStorage) {
      fileContext.setCurrentPath(JSON.parse(currentPathFromStorage));
      setInitialPath(JSON.parse(currentPathFromStorage));
    }
  }, []);




  return (
    <CenterPageLayout disabledHeader={fileContext.isComunity}>
      {/*<Content>*/}
      {/*<Layout*/}
      {/*  style={{*/}
      {/*    backgroundColor: isCommunity() ? "rgba(255,255,255,0.8)" : "",*/}
      {/*    display: "flex",*/}
      {/*    flexWrap: "nowrap",*/}
      {/*  }}*/}
      {/*  className={getClassScreen()}*/}
      {/*>*/}
      <UIModalCreateFolder></UIModalCreateFolder>
      <UIModalUpload></UIModalUpload>
      <UIModalRename></UIModalRename>
      <UIModalMove></UIModalMove>
      <UIModalShare></UIModalShare>
      <UIModalDownload></UIModalDownload>
      <UIShareLinkPopover></UIShareLinkPopover>
      <ManageversionFileContainer></ManageversionFileContainer>
      {/* <UIModalConfrim></UIModalConfrim> */}
      <UIModalConfrimDelete></UIModalConfrimDelete>
      <UIModalConfrimDeleteForever></UIModalConfrimDeleteForever>
      <UIModalConfrimEmptyTrash></UIModalConfrimEmptyTrash>
      <UIModalConfrimDeleteRestore></UIModalConfrimDeleteRestore>
      <UIModalShareFile></UIModalShareFile>
      {!props.isCommunity && <HeaderSearch></HeaderSearch>}
      <Content
        className={styles.FileContent}
        // id="FileFoldersContainer"
        style={{
          width: "auto",
          // overflow: "scroll",
          // height: "101vh",
          flexWrap: "nowrap",
          backgroundColor: isCommunity() ? "rgba(255,255,255,0.8)" : "white",
        }}
      >
        <div
          style={{
            // backgroundColor: "#F1F0F5",
            // minHeight: "100vh",
            display: "flex",
          }}
        >
          <div
            style={{
              backgroundColor: isCommunity() ? "" : "white",
              // minHeight: "100vh",
              position: "absolute",
              // padding: 60,
              width: "100%",
              // display: "flex",
            }}
            className={getClassMainBox()}
          >
            <div className={getClassMainBoxChild()}>
              <div style={{ flex: "0" }} className={styles.backIconMain}>
                <div
                  className={styles.backIcon}
                  style={{ backgroundImage: `url(${backIcon})` }}
                  onClick={handleBack}
                />
              </div>
              <div
                // style={{
                //   width: checkMobile()?"100%": "calc(100% - 320px)",
                //   paddingRight: checkMobile()?0:40,
                // }}
                className={styles.boxFile}
              >
                <Tabs
                  defaultActiveKey={Props.mainTab.files}
                  centered
                  size="large"
                  className={styles.overrideTab}
                  onTabClick={clickTabMain}
                  activeKey={activeKeyMainTab}
                >
                  <TabPane tab={t("Main")} key={Props.mainTab.menu}>
                    <UICoFileMenu
                      setActiveKeyMainTab={(v: any) => {
                        setActiveKeyMainTab(v);
                      }}
                    ></UICoFileMenu>
                  </TabPane>

                  <TabPane tab={t("Files")} key={Props.mainTab.files}>
                    <div
                      id="FileFoldersContainer"
                      className={
                        fileContext.isComunity
                          ? styles.boxFileTabCom
                          : styles.boxFileTab
                      }
                    >
                      {/* {!props.isCommunity || true && ( */}
                      <>
                        {!props.isCommunity && (
                          <div style={{ fontSize: "2rem", fontWeight: 600 }}>
                            {getMainTextOfFile()}
                          </div>
                        )}
                        <div className={styles.headerGroup}>
                          <div className={styles.searchBox}>
                            <Input
                              placeholder={t("Search")}
                              prefix={
                                <SearchOutlined
                                  style={{ paddingRight: "8px" }}
                                />
                              }
                              className={styles.inputSearchBox}
                              // onChange={handleSearchGroupChange}
                              onChange={handlesearchItems}
                              value={fileContext.fileSearchInput}
                            />
                          </div>
                          {checkHiddenBtnCreateUpload ?
                            null : <UIUploadIcon isShared={props.isShared} getRecursiveParents={getRecursiveParents} />
                          }
                          {/* <UIUploadIcon /> */}
                        </div>
                      </>
                      {/* )} */}

                      <div className={styles.boxPath}>
                        {isLoading ? null : showPath() &&
                          getRecursiveParents?.map(
                            (recursiveParent: any, idx: number) => {
                              return (
                                <div style={{ display: "flex" }} key={idx}>
                                  {idx === 0 ? (
                                    <div style={{ display: "flex" }}>
                                      <div
                                        className={styles.pathNotActive}
                                        onClick={() => {
                                          handleClickPath({});
                                        }}
                                      >
                                        {/* {t("My Files")} */}
                                        {checkEmpty(fileContext.groupId)
                                          ? t("My Files")
                                          : t("Group Files")}
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <div style={{ display: "flex" }}>
                                    <div className={styles.symbolPath}>
                                      {t(">")}
                                    </div>
                                    <div
                                      className={
                                        (idx === getRecursiveParents?.length - 1 &&
                                          tabName.manageversion != fileContext.tab ?
                                          styles.pathActive
                                          : getRecursiveParents[idx].file_app_id === "" ?
                                            styles.pathSpotsNotActive
                                            : styles.pathNotActive)
                                      }
                                      onClick={() => {
                                        getRecursiveParents[idx].file_app_id === "" ?
                                          handleClickSpotsPath() : handleClickPath(recursiveParent)
                                      }}
                                    >
                                      {t(recursiveParent.file_name)}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        {(fileContext.tab === tabName.doc ||
                          fileContext.tab === tabName.other ||
                          fileContext.tab === tabName.unknow ||
                          fileContext.tab === tabName.trash ||
                          fileContext.tab === tabName.mediaimage ||
                          fileContext.tab === tabName.mediavideo ||
                          fileContext.tab === tabName.search ||
                          fileContext.tab === tabName.file) && (
                            <div style={{ display: "flex", width: "95%" }}>
                              <div style={{ display: "flex" }}>
                                <div
                                  className={styles.pathNotActive}
                                  onClick={() => {
                                    handleClickMainPath();
                                  }}
                                >
                                  {checkEmpty(fileContext.groupId)
                                    ? t("My Files")
                                    : t("Group Files")}
                                </div>
                              </div>
                              <div style={{ display: "flex" }}>
                                <div className={styles.symbolPath}>{t(">")}</div>
                                <div className={styles.pathActive}>
                                  {getTabText(fileContext.tab)}
                                </div>
                              </div>
                            </div>
                          )}
                        {fileContext.tab === tabName.trash && (
                          <div>
                            <div style={{ flex: "0" }}>

                              <Tooltip placement="bottom" title={t("Empty Trash")} color="#0f4c82">
                                <div
                                  className={styles.emptyTrash}
                                  style={{
                                    backgroundImage: `url(${emptyTrash})`,
                                  }}
                                  onClick={handleClickEmptyTrash}
                                />
                              </Tooltip>
                              {/* <ButtonCenterWeb>
                              <div onClick={handleClickEmptyTrash}>
                                {t("Clear")}
                              </div>
                            </CenterButton> */}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* {fileContext.tab === tabName.manageversion && (
                      <div
                        // justify="start"
                        style={{
                          width: "100%",
                          alignItems: "start",
                          fontWeight: "bold",
                        }}
                      >
                        <div style={{ alignItems: "start", float: "left" }}>
                          <div
                            className={styles.textOverflowListFileText}
                            style={{ alignContent: "left" }}
                          >
                            <div>{fileContext.fileSelected?.file_name}</div>
                          </div>
                        </div>
                        <div style={{ textAlign: "end", float: "right" }}>
                          <div>{getTextVersion()}</div>
                        </div>
                      </div>
                    )} */}
                      <div style={{ marginTop: "8px" }}>
                        {renderContainer(fileContext.tab, fileContext.mainTab)}
                      </div>
                    </div>
                  </TabPane>
                  <TabPane tab={t("Media")} key={Props.mainTab.medias}>
                    <div
                      id="FileMediasContainer"
                      className={
                        fileContext.isComunity
                          ? styles.boxFileTabComMadia
                          : styles.boxFileTabMedia
                      }
                    >
                      {renderContainerMainTab(fileContext.mainTab)}
                    </div>
                  </TabPane>
                  {fileContext.isComunity && (
                    <TabPane tab={t("Links")} key={Props.mainTab.links}>
                      <div
                        className={
                          fileContext.isComunity
                            ? styles.boxFileTabCom
                            : styles.boxFileTab
                        }
                      >
                        {renderContainerMainTab(fileContext.mainTab)}
                      </div>
                    </TabPane>
                  )}
                </Tabs>
              </div>

              {/* <div className={styles.menuFileMobile}></div> */}

              <div className={styles.menuFileWeb}>
                <div className={getTabsClass()}>
                  <UICoFileMenu
                    setActiveKeyMainTab={(v: any) => {
                      setActiveKeyMainTab(v);
                      setPage("files");
                    }}
                  ></UICoFileMenu>
                </div>
              </div>
              {fileContext.showDetail && <BoxDetailFile isShared={props.isShared}></BoxDetailFile>}
            </div>
          </div>
        </div>
        {fileContext.filesSelected?.length != 0 && (
          <div
            className={
              appContext.collapedMenu && window.innerWidth > 600
                ? styles.boxMenuBottomMenuActive
                : styles.boxMenuBottom
            }
          >
            <div className={styles.leftcss}>
              {fileContext.filesSelected?.length +
                " " +
                getItempText() +
                " " +
                t("selected")}
            </div>
            <div className={styles.rightcss} style={{ display: "flex" }}>
              <div className={styles.itemMenu} onClick={downloadMedias}>
                {t("Download")}
              </div>
              {/* <div className={styles.itemMenu} onClick={downloadMedias}>
                  {t("Delete")}
                </div> */}
              <div className={styles.itemMenu} onClick={cancelMedias}>
                {t("Cancel")}
              </div>
              {/* <div className={styles.itemMenu}>:</div> */}
            </div>
          </div>
        )}
      </Content>
      {/*</Layout>*/}
      {/*    </Content>*/}
    </CenterPageLayout>
  );
}

export default function UICoFile(props: any) {
  const { dir, id, tab } = useParams();
  const location = useLocation();
  // let match: any = useRouteMatch(
  //   Props.pathRoutes.File + "/id" + "/:id" + "/folder/:dir"
  // );
  // let matchTab: any = useRouteMatch(
  //   Props.pathRoutes.File + "/id" + "/:id" + "/tab/:tab"
  // );
  // let matchId: any = useRouteMatch(Props.pathRoutes.File + "/id" + "/:id");

  const getId = () => {
    // let id = match?.params?.id; //new URLSearchParams(props.location.search).get("id");
    // if (checkEmpty(id)) id = matchTab?.params?.id;
    // if (checkEmpty(id)) id = matchId?.params?.id;
    // if (id === Props.constKey.myId) id = "";
    // console.log("id:" + id);
    return id;
  };

  const getDirId = () => {
    // let dirid = match?.params?.dir; //new URLSearchParams(props.location.search).get("dirid");

    console.log("dir:" + dir);
    return dir;
  };

  const getTab = () => {
    // let tab = matchTab?.params?.tab; //new URLSearchParams(props.location.search).get("tab");
    return tab;
  };
  const getMainTab = () => {
    let maintab = new URLSearchParams(location.search).get("maintab");
    if (checkEmpty(maintab)) maintab = Props.mainTab.files;
    // console.log("")
    return maintab;
  };
  useEffect(() => { }, []);

  useEffect(() => {
    console.log("isShared uiCo", props.isShared);

  }, [props.isShared])

  return (
    <FileProviderContext>
      <UICoFileContainer
        id={id === Props.constKey.myId ? "" : id}
        dirId={dir}
        isShared={props.isShared}
        // viewdir={getViewdir()}
        tab={tab}
        maintab={getMainTab()}
        isCommunity={false}
      />
    </FileProviderContext>
  );
}

export function UICoFileCommunity(props: any) {
  const { dir, id, tab } = useParams();
  // let match: any = useRouteMatch(
  //   Props.pathRoutes.File + "/id" + "/:id" + "/folder/:dir"
  // );
  // let matchTab: any = useRouteMatch(
  //   Props.pathRoutes.File + "/id" + "/:id" + "/tab/:tab"
  // );
  // let matchId: any = useRouteMatch(Props.pathRoutes.File + "/id" + "/:id");
  const location = useLocation();
  // const getId = () => {
  //   let id = props.id;
  //   console.log("id:" + id);
  //   return id;
  // };
  // const getDirId = () => {
  //   let dirid = props.dirId;
  //
  //   console.log("dir:" + dirid);
  //   return dirid;
  // };
  //
  // const getTab = () => {
  //   let tab = props.tab;
  //   return tab;
  // };
  // const location = useLocation();

  // let match: any = useRouteMatch(
  //   Props.pathRoutes.groupCommunity + "/id" + "/:id" + "/folder/:dir"
  // );
  // let matchTab: any = useRouteMatch(
  //   Props.pathRoutes.groupCommunity + "/id" + "/:id" + "/tab/:tab"
  // );
  // let matchId: any = useRouteMatch(
  //   Props.pathRoutes.groupCommunity + "/id" + "/:id"
  // );

  const getId = () => {
    let fileId: any = id;

    if (fileId === Props.constKey.myId) fileId = "";
    const queryString = new URLSearchParams(location.search);
    if (checkEmpty(fileId)) fileId = queryString.get("id");
    // if (checkEmpty(id)) fileId = matchTab?.params?.id;
    // if (checkEmpty(id)) fileId = matchId?.params?.id;
    return fileId;
  };
  const getDirId = () => {
    // console.log("match?.params : ", match?.params);
    // let dirid = match?.params?.dir;

    return dir;
  };

  const getTab = () => {
    let myTab: any = tab;
    const queryString = new URLSearchParams(location.search);
    if (checkEmpty(myTab)) myTab = queryString.get("tab");
    return tab;
  };
  const getMainTab = () => {
    const queryString = new URLSearchParams(location.search);
    // const id = queryString.get("maintab");
    let maintab = queryString.get("maintab");
    if (checkEmpty(maintab)) maintab = Props.mainTab.files;
    console.log("maintab:" + maintab);
    return maintab;
  };
  useEffect(() => { }, []);
  return (
    <FileProviderContext>
      <UICoFileContainer
        id={id}
        dirId={dir}
        tab={tab}
        maintab={getMainTab()}
        isCommunity={true}
      />
    </FileProviderContext>
  );
}

export function Files(props: any) {
  return (
    <FileProviderContext>
      {props.children}
    </FileProviderContext>
  )
}

export function UICoFileMenu(props: any) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const appContext: any = useContext(AppContext);
  const fileContext: any = useContext(FileContext);

  const getTotalLimitSplit = () => {
    let res = calFreeSize_Split(
      fileContext.aboutLimit?.used,
      fileContext.aboutLimit?.limitSize
    );
    return res;
  };

  const getUsedLimitSplit = () => {
    return bytesToSize_Split(fileContext.aboutLimit?.used);
  };

  const getUsedLimit = () => {
    return fileContext.aboutLimit?.used
      ? bytesToSize(fileContext.aboutLimit?.used)?.replace(" ", "")
      : bytesToSize(0)?.replace(" ", "");
  };

  const getRecursiveParents = () => {
    if (fileContext.groupId === Props.mainState.init) return [];
    if (checkEmpty(fileContext.currentFolder?.recursiveParents)) {
      return [];
    } else {
      let recursiveParents = reverseArr(
        fileContext.currentFolder?.recursiveParents
      );
      return recursiveParents;
    }
  };

  const handleClickTab = (tab: string) => {
    // fileContext.setFileFolders([]);
    fileContext.setMainTab(Props.mainTab.files);
    props.setActiveKeyMainTab(Props.mainTab.files);
    let dirIdText = "";
    // fileContext.setTab(tab);
    // if (tab === tabName.sharedWithMe) {
    //   let dirid = fileContext?.currentSharedWith?.file_app_id;
    //   if (checkEmpty(dirid)) dirid = "";
      // fileContext.setParentFolderId(dirid);
    //   dirIdText = "&dirid=" + dirid;
    // }

    // console.log(parseJwt(Auth.getToken()).userID);
    let id = fileContext.groupId;
    if (checkEmpty(id)) id = "";
    // fileContext.setTab(tab);
    // navigate(
    //   Props.pathRoutes.File + "?id=" + id + "&tab=" + tab + dirIdText
    // );

    // fileContext.setGroupId(id);
    if (checkEmpty(id)) id = Props.constKey.myId;
    if (tab === tabName.sharedWithMe) {
      let dirid = fileContext?.currentSharedWith?.file_app_id;
      if (checkEmpty(dirid)) dirid = "";
      dirIdText = "&dirid=" + dirid;
      fileContext.setParentFolderId(dirid);
      if (fileContext.isComunity) {
        navigate({
          pathname:
            Props.pathRoutes.groupCommunity + "/" + id + "/folder/" + dirid,
          search: `?id=${id}&tab=file`,
        });
      } else
      if (fileContext.currentPath.length > 0) {
        fileContext.setCurrentPath([]);
      }
      navigate(Props.pathRoutes.File + "/id/" + id + "/folder/shared-with-me/" + dirid);
    } else {
      if (fileContext.isComunity) {
        navigate({
          pathname:
            Props.pathRoutes.groupCommunity + "/" + id + "/tab/" + tab,
          search: `?id=${id}&tab=file`,
        });
      } else navigate(Props.pathRoutes.File + "/id/" + id + "/tab/" + tab);
    }
  };

  const getClasActive = (tab: any) => {
    if (tab === fileContext.tab) return styles.boxMenuTabActive;
    else return "";
  };

  const getClasActiveShareWithMe = (tab: any) => {
    if (tab === fileContext.tab) return styles.boxMenuTabActive;
    // let s: any = getRecursiveParents();
    let s: any = reverseArr(fileContext.currentPath)
    if (s.length != 0 && s[0]?.file_name === "Shared with me") {
      return styles.boxMenuTabActive;
    } else return "";
  };

  const getAboutLimitForTab = (tab: any) => {
    let res: any = { fileSize: 0, fileCount: 0 };
    res.fileSize = bytesToSize(0)?.replace(" ", "");
    if (
      checkEmpty(fileContext.aboutLimit) ||
      checkEmpty(fileContext.aboutLimit.tabs)
    )
      return res;
    let tabObj: any = fileContext.aboutLimit?.tabs[tab];
    if (checkEmpty(tabObj)) return res;
    res.fileSize = bytesToSize(tabObj.fileSize)?.replace(" ", "");
    res.fileCount = tabObj.fileCount;
    return res;
  };

  const getFileCountforTab = (tab: any) => {
    let fileCount = getAboutLimitForTab(tab).fileCount;
    let fileCountType: any = t("files");
    if (fileCount == 1) fileCountType = t("file");
    let fileCountText = fileCount + " " + fileCountType;
    return fileCountText;
  };

  const getColorLimitProgress = () => {
    let percent = calPercent(fileContext.aboutLimit);
    if (percent >= 100) {
      return "red";
    } else if (percent >= 90) {
      return "#ffc112";
    } else return "#0f4c82";
  };

  return (
    <div>
      <div style={{ padding: "15px" }}>
        <div
          style={{
            width: "100%",
            display: "inline-flex",
            // justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                backgroundImage: `url(${FolderIcon})`,
                backgroundSize: "cover",
                width: 43,
                height: 36,
              }}
            ></div>
          </div>
          <div
            style={{ marginLeft: "22px", fontSize: "24px", fontWeight: "bold" }}
          >
            <div>{t("Files")}</div>
          </div>
        </div>
        <Row
          style={{
            width: "100%",
            display: "inline-flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Col style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                fontSize: "1.1rem",
                fontWeight: 700,
                minWidth: "50px",
              }}
            >
              {getUsedLimitSplit().size}
            </div>
            <div className={styles.countFileHeaderDes}>
              <Row>
                {getUsedLimitSplit().typeOfSize} {t("Used")}
              </Row>
              {/* <Row>{t("Used")}</Row> */}
            </div>
          </Col>
          <Col style={{ display: "flex", alignItems: "center" }}>
            <div style={{ fontSize: "1.1rem", fontWeight: 700 }}>
              {getTotalLimitSplit().size}
            </div>
            <div className={styles.countFileHeaderDes}>
              <Row>
                {getTotalLimitSplit().typeOfSize} {t("Free")}
              </Row>
              {/* <Row>{t("Free")}</Row> */}
            </div>
          </Col>
        </Row>
        <div style={{ width: "100%", marginTop: 0 }}>
          <div className={styles.boxProgressBar}>
            <Progress
              strokeWidth={7}
              strokeColor={getColorLimitProgress()}
              percent={calPercent(fileContext.aboutLimit)}
              status={"normal"}
            />
          </div>
        </div>
      </div>
      <div
        className={[styles.boxMenuTab, getClasActive(tabName.mediaimage)].join(
          " "
        )}
        onClick={() => {
          handleClickTab(tabName.mediaimage);
        }}
        title={t("Image")}
      >
        <div
          style={{
            backgroundImage: `url(${ImageFile})`,
          }}
          className={styles.iconImg}
        ></div>
        <div className={styles.fileDesc}>
          <div>{t("Image")}</div>
          <div>{getFileCountforTab(tabName.mediaimage)}</div>
        </div>
        <div className={styles.fileSize}>
          {getAboutLimitForTab(tabName.mediaimage).fileSize}
        </div>
      </div>
      {/* HideNotComplete*/}
      <div
        className={[styles.boxMenuTab, getClasActive(tabName.doc)].join(" ")}
        onClick={() => {
          handleClickTab(tabName.doc);
        }}
        title={t("Document")}
      >
        <div
          style={{
            backgroundImage: `url(${DocumentFile})`,
          }}
          className={styles.iconImg}
        ></div>
        <div className={styles.fileDesc}>
          <div>{t("Document")}</div>
          <div>{getFileCountforTab(tabName.doc)}</div>
        </div>
        <div className={styles.fileSize}>
          {getAboutLimitForTab(tabName.doc).fileSize}
        </div>
      </div>

      <div
        className={[styles.boxMenuTab, getClasActive(tabName.mediavideo)].join(
          " "
        )}
        onClick={() => {
          handleClickTab(tabName.mediavideo);
        }}
        title={t("Video")}
      >
        <div
          style={{
            backgroundImage: `url(${MediaFile})`,
          }}
          className={styles.iconImg}
        ></div>
        <div className={styles.fileDesc}>
          <div>{t("Video")}</div>
          <div>{getFileCountforTab(tabName.mediavideo)}</div>
        </div>
        <div className={styles.fileSize}>
          {getAboutLimitForTab(tabName.mediavideo).fileSize}
        </div>
      </div>

      <div
        className={[styles.boxMenuTab, getClasActive(tabName.other)].join(" ")}
        onClick={() => {
          handleClickTab(tabName.other);
        }}
        title={t("Other")}
      >
        <div
          style={{
            backgroundImage: `url(${OtherFile})`,
          }}
          className={styles.iconImg}
        ></div>
        <div className={styles.fileDesc}>
          <div>{t("Other")}</div>
          <div>{getFileCountforTab(tabName.other)}</div>
        </div>
        <div className={styles.fileSize}>
          {getAboutLimitForTab(tabName.other).fileSize}
        </div>
      </div>
      {/* HideNotComplete*/}
      <div
        className={[styles.boxMenuTab, getClasActive(tabName.unknow)].join(" ")}
        onClick={() => {
          handleClickTab(tabName.unknow);
        }}
        title={t("Unknown")}
      >
        <div
          style={{
            backgroundImage: `url(${UnknownFile})`,
          }}
          className={styles.iconImg}
        ></div>
        <div className={styles.fileDesc}>
          <div>{t("Unknown")}</div>
          <div>{getFileCountforTab(tabName.unknow)}</div>
        </div>
        <div className={styles.fileSize}>
          {getAboutLimitForTab(tabName.unknow).fileSize}
        </div>
      </div>

      <div
        className={[
          styles.boxMenuTab,
          getClasActiveShareWithMe(tabName.sharedWithMe),
        ].join(" ")}
        onClick={() => {
          handleClickTab(tabName.sharedWithMe);
        }}
        title={t("Shared With Me")}
      >
        <div
          style={{
            backgroundImage: `url(${SharedWithMeFile})`,
          }}
          className={styles.iconImg}
        ></div>
        <div className={styles.fileDesc}>
          <div>{t("Shared With Me")}</div>
          <div>{getFileCountforTab(tabName.sharedWithMe)}</div>
        </div>
        <div className={styles.fileSize}>
          {getAboutLimitForTab(tabName.sharedWithMe).fileSize}
        </div>
      </div>

      {!isCommunity() && (
        <div
          className={[styles.boxMenuTab, getClasActive(tabName.group)].join(
            " "
          )}
          onClick={() => {
            handleClickTab(tabName.group);
          }}
          title={t("Group")}
        >
          <div
            style={{
              backgroundImage: `url(${GroupFile})`,
            }}
            className={styles.iconImg}
          ></div>
          <div className={styles.fileDesc}>
            <div>{t("Group")}</div>
            <div></div>
          </div>
        </div>
      )}

      <div
        className={[styles.boxMenuTab, getClasActive(tabName.trash)].join(" ")}
        onClick={() => {
          handleClickTab(tabName.trash);
        }}
        title={t("Trash")}
      >
        <div
          style={{
            backgroundImage: `url(${TrashFile})`,
          }}
          className={styles.iconImg}
        ></div>
        <div className={styles.fileDesc}>
          <div>{t("Trash")}</div>
          <div>{getFileCountforTab(tabName.trash)}</div>
        </div>
        <div className={styles.fileSize}>
          {getAboutLimitForTab(tabName.trash).fileSize}
        </div>
      </div>
    </div>
  );
}
